import { gql } from '@apollo/client';
import { BlogPost, BlogPostSummary } from './blogpost';

export interface BlogPostsQuery {
  blogPosts: BlogPostSummary[];
}

export const BLOG_POST_SUMMARY_FRAGMENT = gql`
  fragment BlogPostSummary on BlogPost {
    id
    slug
    title
    intro
    createdAt
    authorName
  }
`;

export const BLOG_POSTS_QUERY = gql`
  query GetLatestBlogPosts($limit: Int) {
    blogPosts(limit: $limit, filter: { statuses: [PUBLISHED] }) {
      thumbnailUrl(options: { w: 300 })
      ...BlogPostSummary
    }
  }
  ${BLOG_POST_SUMMARY_FRAGMENT}
`;

export const BLOG_POST_FRAGMENT = gql`
  fragment BlogPost on BlogPost {
    thumbnailUrl(options: { w: 300 })
    text
    ...BlogPostSummary
  }
  ${BLOG_POST_SUMMARY_FRAGMENT}
`;

export const BLOG_POST_QUERY = gql`
  query GetBlogPosts($slug: String!) {
    blogPost(slug: $slug) {
      ...BlogPost
    }
  }
  ${BLOG_POST_FRAGMENT}
`;

export interface BlogPostQuery {
  blogPost: BlogPost;
}

export interface BlogPostQueryInput {
  slug: string;
}
